<template>
  <section
    id="pricing-plan"
    style="padding:20px;"
  >
    <!-- title text and switch button -->
    <div class="text-center">
        <b-img :src="data.client.logo" style="border:1px solid #ddd;border-radius: 10px;"></b-img>
        <h1 class="my-2">{{ data.client.client_name }}</h1>
      <!-- <div class="d-flex align-items-center justify-content-center mb-5 pb-50">
        <h6 class="mr-1 mb-0">
          Monthly
        </h6>
        <b-form-checkbox
          id="priceSwitch"
          v-model="status"
          name="price-switch"
          value="annually"
          unchecked-value="monthly"
          switch
          @input="tooglePlan"
        />
        <h6 class="ml-50 mb-0">
          Annually
        </h6>
      </div> -->
    </div>
    <!--/ title text and switch button -->

    <!-- pricing plan cards -->
    <b-row class="pricing-card">
      <b-col
        offset-sm-2
        sm="10"
        md="12"
        offset-lg="2"
        lg="10"
        class="mx-auto"
      >
        <b-row>
          <b-col  
            v-for="(membership,index) in data.memberships" :key="index"
            sm="12"
            md="6"
            lg="4"
            >
            <b-card
              align="center"
            >

              <h3>{{membership.plan_name}}</h3>
              <b-card-text>
                {{membership.period_quantity}} {{membership.period_unit}}
              </b-card-text>
              <!-- annual plan -->
              <div class="annual-plan">
                <div class="plan-price mt-2">
                  <sup class="font-medium-1 font-weight-bold text-primary">HKD $</sup>
                  <span class="pricing-basic-value font-weight-bolder text-primary" >{{membership.amount}}</span>
                  <sub class="pricing-duration text-body font-medium-1 font-weight-bold"> / month</sub>
                </div>
              </div>
              <!--/ annual plan -->

              <!-- plan benefit -->
              <b-list-group class="list-group-circle text-left">
                <!-- <b-list-group-item
                  v-for="(data,index) in pricing.basicPlan.planBenefits"
                  :key="index"
                >
                  {{ data }}
                </b-list-group-item> -->
              </b-list-group>
              <!--/ plan benefit -->

              <!-- buttons -->
              <b-button
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                block
                class="mt-2"
                variant="primary"
                @click="url(membership.uuid)"
              >
                Join Now 
              </b-button>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!--/ pricing plan cards -->

<div class="text-center" style="font-size:11px;color:#888;">Power by CloudFit Pro</div>

  </section>
</template>

<script>
import {
  BFormCheckbox, BRow, BCol, BCard, BImg, BCardText, BListGroup, BListGroupItem, BButton, BBadge,
} from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import Ripple from 'vue-ripple-directive'
import router from '@/router'
/* eslint-disable global-require */
export default {
  components: {
    BFormCheckbox,
    BButton,
    router,
    BCardText,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    BCard,
    BBadge,
    BImg,
    AppCollapseItem,
    AppCollapse,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      data:null
    }
  },
  created() {
   this.get_data()
  },
  methods: {
    url(uuid) {
        this.$router.push('/register/'+ this.data.client.web_key +'/?membership='+uuid).then(() => {})
    },
    get_data() {
        this.$http.get(process.env.VUE_APP_API_BASE+`/online-pay/`+ router.currentRoute.params.client_webkey + `/memberships/`)
          .then(res => {
            if (res.data.result === true ) {
             this.data = res.data
            } 
          })
      },
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-pricing.scss';
</style>
